import { V2Shell } from "@/v2/components/V2Shell";
import { Header as V2Header } from "@/v2/components/layout/Header";

/** Every tenant is on the v2 nav; the v1 header (./V1Header) is no longer mounted. */
const Header = () => (
  <V2Shell>
    <V2Header />
  </V2Shell>
);

export default Header;
